import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-header-left__text" }
const _hoisted_2 = { class: "hero main-header-left__title" }
const _hoisted_3 = { class: "main-header-left__title-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "main-header-left__title-wrapper-absolute"
}
const _hoisted_5 = {
  key: 1,
  class: "main-header-left__title-investing",
  style: { marginLeft: '' }
}
const _hoisted_6 = {
  key: 0,
  class: "main-header-left__title-land"
}
const _hoisted_7 = {
  class: "main-header__farm-background",
  width: "935",
  height: "704",
  viewBox: "0 0 935 704",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormGetStarted = _resolveComponent("FormGetStarted")!
  const _component_AsSeenOnLogos = _resolveComponent("AsSeenOnLogos")!
  const _component_ContentHomeSlider = _resolveComponent("ContentHomeSlider")!
  const _component_FarmSlider = _resolveComponent("FarmSlider")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ContentHomeHeader main-header", { 'is--mounted': _ctx.isMounted, 'is--offerings': _ctx.isFarmExist }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["main-header__wrapper", { 'is--no-offerings': !_ctx.isFarmExist, 'is--one-farm': _ctx.isOneFarm }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["main-header__left main-header-left", { 'is--no-offerings': !_ctx.isFarmExist, 'is--offerings': _ctx.isFarmExist, 'is--one-farm': _ctx.isOneFarm }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["main-header-left__wrapper", { 'is--offerings': _ctx.isFarmExist }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (!_ctx.isFarmExist)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_Transition, {
                        mode: "out-in",
                        name: "slide-up"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock("span", {
                            key: _ctx.activeTitle,
                            class: "main-header-left__title-absolute"
                          }, _toDisplayString(_ctx.activeTitle), 1))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isFarmExist)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Investing."))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isFarmExist)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Farmland Investing."))
                : _createCommentVNode("", true),
              _cache[2] || (_cache[2] = _createElementVNode("div", null, "Simplified.", -1))
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "is-h3__title subheading main-header-left__subheading" }, " Diversify with an asset class that has the potential to create wealth opportunities over time. ", -1))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["main-header__get-started", { 'is--not-logged-in': !_ctx.isLoggedIn }])
          }, [
            _createVNode(_component_FormGetStarted, {
              class: "",
              "is-logged-in": _ctx.isLoggedIn
            }, null, 8, ["is-logged-in"])
          ], 2)
        ], 2),
        _createVNode(_component_AsSeenOnLogos, {
          class: _normalizeClass(["main-header__as-seen-on-logos", { 'is--offerings': _ctx.isFarmExist }])
        }, null, 8, ["class"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["main-header__right main-header-right", { 'is--no-offerings': !_ctx.isFarmExist }])
      }, [
        (!_ctx.isFarmExist)
          ? (_openBlock(), _createBlock(_component_ContentHomeSlider, {
              key: 0,
              class: "main-header-right__pattern-slider",
              onSliderImageChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sliderCurrentImage = $event)),
              onCurrentSlideChange: _ctx.onCurrentSlideChange
            }, null, 8, ["onCurrentSlideChange"]))
          : _createCommentVNode("", true),
        (_ctx.isFarmExist)
          ? (_openBlock(), _createBlock(_component_FarmSlider, {
              key: 1,
              class: "main-header-right__slider",
              onSliderImageChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sliderCurrentImage = $event))
            }))
          : _createCommentVNode("", true),
        (_openBlock(), _createElementBlock("svg", _hoisted_7, [
          _cache[4] || (_cache[4] = _createElementVNode("defs", null, [
            _createElementVNode("clipPath", { id: "circleView" }, [
              _createElementVNode("path", {
                d: "M0 0H935V704L351 267L0 0Z",
                fill: "white"
              })
            ])
          ], -1)),
          _createElementVNode("image", {
            clas: "main-header__farm-background-image",
            href: _ctx.sliderCurrentImage,
            "clip-path": "url(#circleView)"
          }, null, 8, _hoisted_8)
        ]))
      ], 2)
    ], 2),
    _createVNode(_component_AsSeenOnLogos, {
      class: _normalizeClass(["main-header__as-seen-on-logos is--bottom", { 'is--no-offerings': !_ctx.isFarmExist }])
    }, null, 8, ["class"])
  ], 2))
}